import { buildProps } from '@ll-plus/utils'
import { ExtractPropTypes } from 'vue'
import type TimeRange from './time-range.vue'

export const timeRangeProps = buildProps({
  // 分隔符图标
  separatorIcon: {
    type: String,
    default: '',
  },
  // 分隔符文本
  separatorText: {
    type: String,
    default: '',
  },
  isGray: {
    type: Boolean,
    default: false,
  },
  // 占位符
  placeholder: {
    type: Array,
    default: () => ['请选择', '请选择'],
  },
  // 起始占位符
  startPlaceholder: String,
  // 结束占位符
  endPlaceholder: String,
} as const)

// props
export type TimeRangeProps = ExtractPropTypes<typeof timeRangeProps>

// instance
export type TimeRangeInstance = InstanceType<typeof TimeRange>
